import { createHook } from '@atlassian/eoc-rss-helpers';

import { type ScheduleEntity } from '../../../services/endpoints/list/types';
import { type actions } from '../actions';
import { store } from '../index';
import { selectors } from '../selectors';
import { type initialState } from '../state';

const useShiftRelatedModalOpen = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getShiftRelatedModalOpen>,
	ScheduleEntity
>(store, {
	selector: selectors.getShiftRelatedModalOpen,
});

export { useShiftRelatedModalOpen };
